var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconBase",on:{"click":_vm.iconClick}},[_c(_vm.name,{tag:"component",attrs:{"width":_vm.width,"height":_vm.height,"color":_vm.color,"is-fill":_vm.isFill}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34153780","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/common/icon/IconBase.vue
// module id = null
// module chunks = 